import { Component } from '@angular/core';
import { BUNDLED_LOGO_DATA_URI } from '@core/assets/bundled-logo';

@Component({
  selector: 'app-page-loader',
  styles: [
    `
      .logo-shimmer-wrapper {
        position: relative;
        display: inline-block;
        overflow: hidden;
      }

      .logo-shimmer-wrapper::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 60%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.65), transparent);
        animation: logo-shimmer-sweep 1.6s ease-in-out infinite;
      }

      @keyframes logo-shimmer-sweep {
        0% {
          transform: translateX(-120%);
        }
        100% {
          transform: translateX(220%);
        }
      }
    `,
  ],
  template: `
    <!--
      The logo is a bundled data URI (BUNDLED_LOGO_DATA_URI), not a src="images/..." reference, so it renders
      with the same zero-network-dependency guarantee as everything else on this screen.
    -->
    <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
      <div class="logo-shimmer-wrapper">
        <img [src]="bundledLogoDataUri" alt="Shikenso" width="220" />
      </div>
    </div>
  `,
})
export class PageLoaderComponent {
  public readonly bundledLogoDataUri = BUNDLED_LOGO_DATA_URI;
}
